var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoStoriesIllustration = function SvgNoStoriesIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.776 21.93a5.92 5.92 0 0 1 5.1-6.646l71.236-9.345a5.932 5.932 0 0 1 6.652 5.104l12.173 92.196a5.92 5.92 0 0 1-5.1 6.646L19.6 119.229a5.931 5.931 0 0 1-6.651-5.104L.776 21.929Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.21 6.673 5.973 16.018a5.18 5.18 0 0 0-4.463 5.815l12.173 92.196a5.19 5.19 0 0 0 5.82 4.466l71.237-9.345a5.18 5.18 0 0 0 4.463-5.815L83.029 11.14a5.19 5.19 0 0 0-5.82-4.467Zm-71.334 8.61a5.92 5.92 0 0 0-5.1 6.646l12.173 92.196a5.931 5.931 0 0 0 6.651 5.104l71.237-9.344a5.92 5.92 0 0 0 5.1-6.646L83.764 11.043a5.932 5.932 0 0 0-6.651-5.104L5.876 15.284Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.223 5.926A5.926 5.926 0 0 1 28.149 0h58.775c.784 0 1.536.31 2.092.864l15.168 15.119a5.927 5.927 0 0 1 1.742 4.197v78.736a5.926 5.926 0 0 1-5.926 5.926H28.149a5.926 5.926 0 0 1-5.926-5.926V5.926Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.186 98.916V20.18c0-1.378-.549-2.7-1.525-3.672L88.493 1.389a2.222 2.222 0 0 0-1.569-.648H28.15a5.185 5.185 0 0 0-5.186 5.185v92.99a5.185 5.185 0 0 0 5.186 5.185H100a5.185 5.185 0 0 0 5.186-5.185ZM28.149 0a5.926 5.926 0 0 0-5.926 5.926v92.99a5.926 5.926 0 0 0 5.926 5.926H100a5.926 5.926 0 0 0 5.926-5.926V20.18a5.927 5.927 0 0 0-1.742-4.197L89.016.864A2.963 2.963 0 0 0 86.924 0H28.15Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.297 14.747V0h.74v14.747a5.556 5.556 0 0 0 5.556 5.556h13.334v.74H92.593a6.296 6.296 0 0 1-6.296-6.296Z",
    fill: "#9CA3AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.112 31.748H37.038v-.74h54.074v.74ZM91.112 43.561H37.038v-.74h54.074v.74ZM91.112 55.374H37.038v-.74h54.074v.74ZM91.112 67.188H37.038v-.741h54.074v.74ZM64.445 79H37.038v-.74h27.407V79Z",
    fill: "#6B7280"
  })));
};
export default SvgNoStoriesIllustration;